"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatMessage = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _Avatar = require("../Avatar");

var _Layout = require("../Layout");

var _Typography = require("../Typography/Typography");

var backgroundColorTransition = 'background-color 0.2s ease-out';
var StyledChatMessage = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "ChatMessage__StyledChatMessage",
  componentId: "sc-88gjrs-0"
})(_styledSystem.layout, (0, _css.default)({
  transition: backgroundColorTransition,
  ':hover': {
    backgroundColor: 'copoazu',
    transition: backgroundColorTransition
  }
}));
var StyledAuthorText = (0, _styledComponents.default)(_Typography.TypographyBase).withConfig({
  displayName: "ChatMessage__StyledAuthorText",
  componentId: "sc-88gjrs-1"
})({
  whiteSpace: 'nowrap'
}, (0, _styledSystem.variant)({
  prop: 'type',
  variants: {
    default: {
      color: 'sonar'
    },
    primary: {
      color: 'rambutan'
    },
    secondary: {
      color: 'quandog'
    }
  }
}));
var StyledMessageText = (0, _styledComponents.default)(_Typography.TypographyBase).withConfig({
  displayName: "ChatMessage__StyledMessageText",
  componentId: "sc-88gjrs-2"
})(["word-break:break-word;"]);
var commonTextProps = {
  as: 'span',
  size: 'tiny',
  margin: 0,
  textAlign: 'left'
};

var MessageContent = _react.default.memo(function (_ref) {
  var type = _ref.type,
      author = _ref.author,
      message = _ref.message,
      authorRef = _ref.authorRef,
      messageRef = _ref.messageRef;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(StyledAuthorText, (0, _extends2.default)({}, commonTextProps, {
    fontWeight: "medium",
    type: type,
    ref: authorRef
  }), author, ":"), _react.default.createElement("span", null, " "), _react.default.createElement(StyledMessageText, (0, _extends2.default)({}, commonTextProps, {
    fontWeight: "regular",
    ref: messageRef
  }), message));
});

var MessageDisplay = _react.default.memo(function (_ref2) {
  var flexMessageDisplay = _ref2.flexMessageDisplay,
      type = _ref2.type,
      author = _ref2.author,
      message = _ref2.message,
      authorRef = _ref2.authorRef,
      messageRef = _ref2.messageRef;

  var getMessage = function getMessage() {
    return _react.default.createElement(MessageContent, {
      author: author,
      message: message,
      authorRef: authorRef,
      messageRef: messageRef,
      type: type
    });
  };

  if (flexMessageDisplay) {
    return _react.default.createElement(_Layout.Flex, {
      alignItems: "center",
      height: "100%"
    }, getMessage());
  }

  return getMessage();
});

var AvatarContent = _react.default.memo(function (_ref3) {
  var url = _ref3.url;
  return _react.default.createElement(_Avatar.Avatar, {
    src: url,
    size: "micro"
  });
});

var AvatarDisplay = _react.default.memo(function (_ref4) {
  var flexMessageDisplay = _ref4.flexMessageDisplay,
      avatar = _ref4.avatar;

  var getAvatar = function getAvatar() {
    return _react.default.createElement(AvatarContent, {
      url: avatar
    });
  };

  if (flexMessageDisplay) {
    return _react.default.createElement(_Layout.Flex, {
      alignItems: "center",
      height: "100%"
    }, getAvatar());
  }

  return getAvatar();
});

var ChatMessage = function ChatMessage(_ref5) {
  var _chatMessageRef$curre2, _authorRef$current2, _messageRef$current2;

  var avatar = _ref5.avatar,
      author = _ref5.author,
      message = _ref5.message,
      type = _ref5.type,
      props = (0, _objectWithoutProperties2.default)(_ref5, ["avatar", "author", "message", "type"]);
  var chatMessageRef = (0, _react.useRef)(null);
  var authorRef = (0, _react.useRef)(null);
  var messageRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      flexMessageDisplay = _useState2[0],
      setFlexMessageDisplay = _useState2[1];

  var isTextShorterThanContainer = _react.default.useCallback(function () {
    var _chatMessageRef$curre, _authorRef$current, _messageRef$current;

    var chatMessageWidth = chatMessageRef === null || chatMessageRef === void 0 ? void 0 : (_chatMessageRef$curre = chatMessageRef.current) === null || _chatMessageRef$curre === void 0 ? void 0 : _chatMessageRef$curre.offsetWidth;
    var authorWidth = authorRef === null || authorRef === void 0 ? void 0 : (_authorRef$current = authorRef.current) === null || _authorRef$current === void 0 ? void 0 : _authorRef$current.offsetWidth;
    var messageWidth = messageRef === null || messageRef === void 0 ? void 0 : (_messageRef$current = messageRef.current) === null || _messageRef$current === void 0 ? void 0 : _messageRef$current.offsetWidth;
    return authorWidth + messageWidth < chatMessageWidth;
  }, [chatMessageRef === null || chatMessageRef === void 0 ? void 0 : (_chatMessageRef$curre2 = chatMessageRef.current) === null || _chatMessageRef$curre2 === void 0 ? void 0 : _chatMessageRef$curre2.offsetWidth, authorRef === null || authorRef === void 0 ? void 0 : (_authorRef$current2 = authorRef.current) === null || _authorRef$current2 === void 0 ? void 0 : _authorRef$current2.offsetWidth, messageRef === null || messageRef === void 0 ? void 0 : (_messageRef$current2 = messageRef.current) === null || _messageRef$current2 === void 0 ? void 0 : _messageRef$current2.offsetWidth]);

  (0, _react.useEffect)(function () {
    setFlexMessageDisplay(isTextShorterThanContainer());
  }, [message]);
  return _react.default.createElement(StyledChatMessage, (0, _extends2.default)({}, props, {
    paddingX: [1, 1, 1],
    paddingY: [2, 2, 2],
    borderRadius: 3
  }), _react.default.createElement(_Layout.Grid, {
    gridColumnGap: [1, 1, 1],
    gridTemplateColumns: "32px 1fr"
  }, _react.default.createElement(_Layout.GridItem, {
    gridRow: 1,
    gridCol: 1
  }, _react.default.createElement(AvatarDisplay, {
    flexMessageDisplay: flexMessageDisplay,
    avatar: avatar
  })), _react.default.createElement(_Layout.GridItem, {
    gridRow: 1,
    gridCol: 2,
    style: {
      whiteSpace: 'pre-wrap'
    },
    ref: chatMessageRef
  }, _react.default.createElement(MessageDisplay, {
    flexMessageDisplay: flexMessageDisplay,
    author: author,
    message: message,
    authorRef: authorRef,
    messageRef: messageRef,
    type: type
  }))));
};

exports.ChatMessage = ChatMessage;
ChatMessage.defaultProps = {
  avatar: '',
  type: 'default',
  width: '332px'
};